import { useEffect } from "react";
import { useAuthStore } from "../stores/authStore";

export const useAuth = () => {
  const {
    token,
    user,
    isAuthenticated,
    hasHydrated,
    isLoading,
    error,
    login,
    loginWithSSO,
    logout,
    clearError,
    checkTokenExpiration,
  } = useAuthStore();

  // Verifica expiração do token ao montar o componente
  useEffect(() => {
    checkTokenExpiration();
  }, [checkTokenExpiration]);

  const isAdmin = user?.role === "admin";
  const isClient = user?.role === "client";

  return {
    token,
    user,
    isAuthenticated,
    hasHydrated,
    isLoading,
    error,
    isAdmin,
    isClient,
    login,
    loginWithSSO,
    logout,
    clearError,
  };
};
